import { secsData } from './secsDataLoader';
import type { DataItemDefinition, DataItemCode, MessageDataItem } from '../types/secs';
import { isDataItemRef } from '../types/secs';

export function getDataItemDefinition(name: string): DataItemDefinition | null {
  return secsData.dataItems?.[name] ?? null;
}

export function getAllDataItems(): DataItemDefinition[] {
  if (!secsData.dataItems) return [];
  return Object.values(secsData.dataItems).sort((a, b) => a.name.localeCompare(b.name));
}

export interface ResolvedDataItem {
  name: string;
  type: string;
  length?: string;
  description: string;
  required: boolean;
  codes?: DataItemCode[];
  definition: DataItemDefinition | null;
}

export function resolveMessageDataItem(item: MessageDataItem): ResolvedDataItem {
  if (isDataItemRef(item)) {
    const def = getDataItemDefinition(item.ref);
    return {
      name: item.ref,
      type: def?.type ?? '?',
      length: item.length ?? def?.length,
      description: item.description ?? def?.description ?? '',
      required: item.required ?? true,
      codes: def?.codes,
      definition: def,
    };
  }
  return {
    name: item.name,
    type: item.type,
    length: typeof item.length === 'number' ? String(item.length) : item.length,
    description: item.description,
    required: item.required,
    codes: undefined,
    definition: getDataItemDefinition(item.name),
  };
}
